import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { FEATURES_BASE_PATH } from '../../constants/featuresBasePath';
import { getFeatures } from '../../requests/getFeatures';

export const useFeatures = () => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getFeatures>>
  >({
    queryKey: [FEATURES_BASE_PATH],
    queryFn: () => getFeatures(constructGet),
    staleTime: Infinity,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'features'),
    ...rest,
  };
};
